module.exports = __webpack_public_path__ + "img/check.beb8a7d4.svg";